module.exports = __webpack_public_path__ + "static/media/sliderItem8.3cc09042.JPG";